import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import CalendarView from "./pages/CalendarView";
import ConfirmAppointment from "./pages/ConfirmAppointment";
import AdminPanel from "./pages/AdminPanel";
import Statistics from "./pages/Statistics";
import LandingPage from "./pages/LandingPage";
import LandingAdmin from "./pages/admin/LandingAdmin";
import PushAdmin from "./pages/admin/PushAdmin";
import FinanceAdmin from "./pages/admin/FinanceAdmin";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DeleteAccount from "./pages/DeleteAccount";

// Apply dark mode immediately on app load (before React renders)
const initializeDarkMode = () => {
  const darkMode = localStorage.getItem('darkMode') === 'true';
  if (darkMode) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
};

// Call immediately
initializeDarkMode();

function App() {
  // Also apply on mount in case localStorage changes
  useEffect(() => {
    initializeDarkMode();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/calendar" element={<CalendarView />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/admin/landing" element={<LandingAdmin />} />
          <Route path="/admin/push" element={<PushAdmin />} />
          <Route path="/admin/finance" element={<FinanceAdmin />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/politica-privacidad" element={<PrivacyPolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/eliminar-cuenta" element={<DeleteAccount />} />
          <Route path="/confirmar-cita" element={<ConfirmAppointment />} />
          <Route path="/c" element={<ConfirmAppointment />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
